import { render, staticRenderFns } from "./ModalContato.vue?vue&type=template&id=c07134f6"
import script from "./ModalContato.vue?vue&type=script&lang=ts"
export * from "./ModalContato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports